import React, { useState } from 'react'
import { Row, Col, FormGroup, Label, Input, Button, Spinner } from 'reactstrap'
import { Typography } from '@material-ui/core'
import { useFirebase } from 'react-redux-firebase'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { isValidEmail } from '../utils/validation'

const isValidPhone = (v) => typeof v === 'string' && /^\+?[0-9\s-]{6,20}$/.test(v.trim())

// Collects the guest purchaser's contact details and stores them as the minimal
// users/{uid} doc the backend expects for anonymous (guest) reservations.
function GuestContactForm({ auth, profile, onSaved }) {
  const firebase = useFirebase()
  const { t } = useTranslation()
  const [firstname, setFirstname] = useState((profile && profile.firstname) || '')
  const [lastname, setLastname] = useState((profile && profile.lastname) || '')
  const [email, setEmail] = useState((profile && profile.email) || '')
  const [phone, setPhone] = useState((profile && profile.phone) || '')
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)
  const [error, setError] = useState(false)

  const isValid = firstname && lastname && isValidEmail(email) && isValidPhone(phone)

  const save = async () => {
    if (!isValid || saving) return
    setSaving(true)
    setError(false)
    try {
      await firebase
        .firestore()
        .collection('users')
        .doc(auth.uid)
        .set(
          {
            email: email.trim(),
            firstname: firstname.trim(),
            lastname: lastname.trim(),
            phone: phone.trim(),
            isguest: true,
            created: moment.utc().format(),
          },
          { merge: true }
        )
      setSaved(true)
      if (onSaved) onSaved()
    } catch (e) {
      setError(true)
    }
    setSaving(false)
  }

  return (
    <div style={{ marginBottom: 15 }}>
      <Typography variant='subtitle1' style={{ marginBottom: 5 }}>
        {t('guest_contact_info')}
      </Typography>
      <Row>
        <Col sm={6}>
          <FormGroup className='loose-form'>
            <Label for='guestfirstname'>{t('first_name')} *</Label>
            <Input
              type='text'
              id='guestfirstname'
              value={firstname}
              disabled={saved}
              onChange={(event) => setFirstname(event.target.value)}
            />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup className='loose-form'>
            <Label for='guestlastname'>{t('last_name')} *</Label>
            <Input
              type='text'
              id='guestlastname'
              value={lastname}
              disabled={saved}
              onChange={(event) => setLastname(event.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <FormGroup className='loose-form'>
            <Label for='guestemail'>{t('email')} *</Label>
            <Input
              type='email'
              id='guestemail'
              value={email}
              disabled={saved}
              invalid={Boolean(email && !isValidEmail(email))}
              onChange={(event) => setEmail(event.target.value)}
            />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup className='loose-form'>
            <Label for='guestphone'>{t('phone')} *</Label>
            <Input
              type='tel'
              id='guestphone'
              value={phone}
              disabled={saved}
              invalid={Boolean(phone && !isValidPhone(phone))}
              onChange={(event) => setPhone(event.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      {error ? (
        <Typography variant='body2' color='error' style={{ marginBottom: 10 }}>
          {t('guest_error_generic')}
        </Typography>
      ) : null}
      {!saved ? (
        <Button size='sm' color='primary' disabled={!isValid || saving} onClick={() => save()}>
          {saving ? <Spinner size='sm' /> : t('save')}
        </Button>
      ) : (
        <Typography variant='body2' style={{ color: 'green' }}>
          {t('saved')}
        </Typography>
      )}
    </div>
  )
}

export default GuestContactForm
